import axios from 'axios';

let creds = {};

async function getCredentials() {
  if (keyExpiredOrNotExists(creds)) {
    try {
      const response = await axios({
        method: 'get',
        url: process.env.REACT_APP_SSO_TOKEN_URL,
        withCredentials: true,
      });

      if (!response.data || response.data.errorMessage) {
        throw new Error(
          (response.data && response.data.errorMessage) ||
            'SSO server returned no credentials'
        );
      }

      creds = response.data;

      return {
        accessKeyId: response.data.accessKeyId,
        secretAccessKey: response.data.secretAccessKey,
        sessionToken: response.data.sessionToken,
      };
    } catch (e) {
      // Do NOT swallow into `undefined`: that turns a transient SSO/cookie
      // failure into "Cannot destructure ... of undefined" downstream and a
      // permanent stuck-on-logo. Surface the real error to the caller.
      console.error('getCredentials failed', e);
      throw e;
    }
  } else {
    return creds;
  }
}

const keyExpiredOrNotExists = (creds) =>
  !creds.keyExpiration || Math.floor(Date.now() / 1000) > creds.keyExpiration;

export default getCredentials;
